import { logEvent } from 'commons/utils/tracking';
import {
  NUVEM_ENVIO_CLICK,
  NUVEM_ENVIO_COMMUNICATION,
  NUVEM_ENVIO_POPOVER_UNPACKED_VIEW,
  NUVEM_ENVIO_POPOVER_UNPACKED_CLOSE,
  NUVEM_ENVIO_POPOVER_UNPACKED_CLICK,
  NUVEM_ENVIO_POPOVER_UNPACKED_PAGE,
  NUVEM_ENVIO_POPOVER_UNPACKED_TYPE,
  NUVEM_ENVIO_POPOVER_UNPACKED_VIEW_ACTION,
  NUVEM_ENVIO_POPOVER_UNPACKED_CLOSE_ACTION,
  NUVEM_ENVIO_POPOVER_UNPACKED_LINK_ACTION,
  NUVEM_ENVIO_PRINT_LABELS_MODAL_VIEW,
  NUVEM_ENVIO_PRINT_LABELS_MODAL_CANCEL_BUTTON,
  NUVEM_ENVIO_PRINT_LABELS_MODAL_CONTINUE_BUTTON,
  NUVEM_ENVIO_PRINT_LABELS_VIEW,
  NUVEM_ENVIO_PRINT_LABELS_VIEW_ERROR,
  NUVEM_ENVIO_PRINT_LABELS_VIEW_SUCCESS,
  NUVEM_ENVIO_PRINT_LABELS_VIEW_WAITING_PAYMENT,
  NUVEM_ENVIO_PRINT_LABELS_VIEW_WAITING_PAYMENT_BUTTON,
  NUVEM_ENVIO_PRINT_LABELS_BUTTON_ORDER_DETAILS,
  NUVEM_ENVIO_CYBER_MONDAY_BANNER_CLOSE,
  NUVEM_ENVIO_CYBER_MONDAY_BANNER_CLICK,
  NUVEM_ENVIO_BLACK_FRIDAY_BANNER_CLICK,
  NUVEM_ENVIO_BLACK_FRIDAY_BANNER_CLOSE,
  NUVEM_ENVIO_LOGGI_BANNER_CLICK,
  NUVEM_ENVIO_LOGGI_BANNER_CLOSE,
  NUVEM_ENVIO_CUSTOM_ORDER_BANNER_CLICK,
  NUVEM_ENVIO_CUSTOM_ORDER_BANNER_CLOSE,
  NUVEM_ENVIO_CYBER_MONDAY_RATE_BANNER_CLICK,
  NUVEM_ENVIO_CYBER_MONDAY_RATE_BANNER_CLOSE,
  NUVEM_ENVIO_LOGGI_BANNER_ACTIVATE_BUTTON_CLICK,
  NUVEM_ENVIO_LOGGI_BANNER_CLOSE_BUTTON_CLICK,
  NUVEM_ENVIO_PRINT_DOCUMENTS_PAGE_VIEW,
  NUVEM_ENVIO_PRINT_DOCUMENTS_BUTTON_CONFIRM_CLICK,
  NUVEM_ENVIO_PRINT_DOCUMENTS_BUTTON_CANCEL_CLICK,
  NUVEM_ENVIO_PRINT_DOCUMENTS_GENERATING_START_LABELS,
  NUVEM_ENVIO_PRINT_DOCUMENTS_GENERATED_PRINT_LABELS_CLICK,
  NUVEM_ENVIO_PRINT_DOCUMENTS_GENERATED_SUCCESS_LABELS,
  NUVEM_ENVIO_PRINT_DOCUMENTS_GENERATED_ERROR_LABELS,
} from 'config/trackingEvents';

export const trackingCommunication = (
  type: 'jadlog' | 'correios',
  page: 'shipping' | 'orders',
) => {
  logEvent(NUVEM_ENVIO_COMMUNICATION, {
    type,
    page,
  });
};

export const trackingCommunicationButton = (
  type: 'jadlog' | 'correios',
  page: 'shipping' | 'orders',
  action?: string,
) => {
  if (action) {
    logEvent(NUVEM_ENVIO_CLICK, {
      type,
      page,
      action,
    });
  } else {
    logEvent(NUVEM_ENVIO_CLICK, {
      type,
      page,
    });
  }
};

export const trackingNuvemEnvioPopoverUnpackedView = (storeId: string) => {
  logEvent(NUVEM_ENVIO_POPOVER_UNPACKED_VIEW, {
    storeId,
    page: NUVEM_ENVIO_POPOVER_UNPACKED_PAGE,
    popover: NUVEM_ENVIO_POPOVER_UNPACKED_TYPE,
    action: NUVEM_ENVIO_POPOVER_UNPACKED_VIEW_ACTION,
  });
};

export const trackingNuvemEnvioPopoverUnpackedClose = (storeId: string) => {
  logEvent(NUVEM_ENVIO_POPOVER_UNPACKED_CLOSE, {
    storeId,
    page: NUVEM_ENVIO_POPOVER_UNPACKED_PAGE,
    popover: NUVEM_ENVIO_POPOVER_UNPACKED_TYPE,
    action: NUVEM_ENVIO_POPOVER_UNPACKED_CLOSE_ACTION,
  });
};

export const trackingNuvemEnvioPopoverUnpackedClick = (storeId: string) => {
  logEvent(NUVEM_ENVIO_POPOVER_UNPACKED_CLICK, {
    storeId,
    page: NUVEM_ENVIO_POPOVER_UNPACKED_PAGE,
    popover: NUVEM_ENVIO_POPOVER_UNPACKED_TYPE,
    action: NUVEM_ENVIO_POPOVER_UNPACKED_LINK_ACTION,
  });
};

export const trackingNuvemEnvioPrintLabels = (storeId: string) => {
  logEvent(NUVEM_ENVIO_PRINT_LABELS_VIEW, {
    storeId,
  });
};

export const trackingNuvemEnvioPrintLabelsError = (
  storeId: string,
  page: string,
) => {
  logEvent(NUVEM_ENVIO_PRINT_LABELS_VIEW_ERROR, {
    storeId,
    page,
  });
};

export const trackingNuvemEnvioPrintLabelsSuccess = (
  storeId: string,
  page: string,
) => {
  logEvent(NUVEM_ENVIO_PRINT_LABELS_VIEW_SUCCESS, {
    storeId,
    page,
  });
};

export const trackingNuvemEnvioPrintLabelsWaitingPayment = (
  storeId: string,
) => {
  logEvent(NUVEM_ENVIO_PRINT_LABELS_VIEW_WAITING_PAYMENT, {
    storeId,
  });
};

export const trackingNuvemEnvioPrintLabelsOrderDetails = (orderId: string) => {
  logEvent(NUVEM_ENVIO_PRINT_LABELS_BUTTON_ORDER_DETAILS, {
    orderId,
  });
};

export const trackingNuvemEnvioPrintLabelsWaitingPaymentButton = (
  storeId: string,
) => {
  logEvent(NUVEM_ENVIO_PRINT_LABELS_VIEW_WAITING_PAYMENT_BUTTON, {
    storeId,
  });
};

export const trackingNuvemEnvioCreditRechargeLabelsModal = (
  storeId: string,
  orderQuantity: number,
  totalAmount: number,
  availableCredit: number,
) => {
  logEvent(NUVEM_ENVIO_PRINT_LABELS_MODAL_VIEW, {
    storeId,
    order_quantity: orderQuantity.toString(),
    total_amount: totalAmount.toString(),
    available_credit: availableCredit.toString(),
  });
};

export const trackingNuvemEnvioCreditRechargeLabelsModalCancelButton = (
  storeId: string,
  orderQuantity: number,
  totalAmount: number,
) => {
  logEvent(NUVEM_ENVIO_PRINT_LABELS_MODAL_CANCEL_BUTTON, {
    storeId,
    order_quantity: orderQuantity.toString(),
    total_amount: totalAmount.toString(),
  });
};
export const trackingNuvemEnvioCreditRechargeLabelsModalContinueButton = ({
  storeId,
  orderQuantity,
  totalAmount,
  finalAmount,
  hasCreditApplied,
}: {
  storeId: string;
  orderQuantity: number;
  totalAmount: number;
  finalAmount: number;
  hasCreditApplied: boolean;
}) => {
  logEvent(NUVEM_ENVIO_PRINT_LABELS_MODAL_CONTINUE_BUTTON, {
    storeId,
    order_quantity: orderQuantity.toString(),
    total_amount: totalAmount.toString(),
    final_amount: finalAmount.toString(),
    has_credit_applied: hasCreditApplied.toString(),
  });
};

export const trackingNuvemEnvioCyberMondayBannerClick = () => {
  logEvent(NUVEM_ENVIO_CYBER_MONDAY_BANNER_CLICK, {});
};

export const trackingNuvemEnvioCyberMondayBannerClose = () => {
  logEvent(NUVEM_ENVIO_CYBER_MONDAY_BANNER_CLOSE, {});
};

export const trackingNuvemEnvioBlackFridayBannerClick = () => {
  logEvent(NUVEM_ENVIO_BLACK_FRIDAY_BANNER_CLICK, {});
};

export const trackingNuvemEnvioBlackFridayBannerClose = () => {
  logEvent(NUVEM_ENVIO_BLACK_FRIDAY_BANNER_CLOSE, {});
};

export const trackingNuvemEnvioLoggiBannerClick = () => {
  logEvent(NUVEM_ENVIO_LOGGI_BANNER_CLICK, {});
};

export const trackingNuvemEnvioLoggiBannerClose = () => {
  logEvent(NUVEM_ENVIO_LOGGI_BANNER_CLOSE, {});
};

export const trackingNuvemEnvioCyberMondayRateBannerClick = () => {
  logEvent(NUVEM_ENVIO_CYBER_MONDAY_RATE_BANNER_CLICK, {});
};

export const trackingNuvemEnvioCyberMondayRateBannerClose = () => {
  logEvent(NUVEM_ENVIO_CYBER_MONDAY_RATE_BANNER_CLOSE, {});
};

export const trackingNuvemEnvioCustomOrderBannerClose = () => {
  logEvent(NUVEM_ENVIO_CUSTOM_ORDER_BANNER_CLOSE, { page: 'shipping' });
};

export const trackingNuvemEnvioCustomOrderBannerClick = () => {
  logEvent(NUVEM_ENVIO_CUSTOM_ORDER_BANNER_CLICK, { page: 'shipping' });
};

export const trackingNuvemEnvioLoggiBannerActivate = () => {
  logEvent(NUVEM_ENVIO_LOGGI_BANNER_ACTIVATE_BUTTON_CLICK, {
    page: 'shipping',
  });
};

export const trackingNuvemEnvioLoggiBannerCloseButton = () => {
  logEvent(NUVEM_ENVIO_LOGGI_BANNER_CLOSE_BUTTON_CLICK, { page: 'shipping' });
};

export const trackingNuvemEnvioPrintDocumentsPage = (orderCount: number) => {
  logEvent(NUVEM_ENVIO_PRINT_DOCUMENTS_PAGE_VIEW, {
    order_count: orderCount.toString(),
  });
};

export const trackingNuvemEnvioPrintDocumentsPageButtonConfirm = (
  orderId: string,
  hasMultipleOrders: boolean,
  action: 'confirm' | 'cancel',
) => {
  logEvent(
    action === 'confirm'
      ? NUVEM_ENVIO_PRINT_DOCUMENTS_BUTTON_CONFIRM_CLICK
      : NUVEM_ENVIO_PRINT_DOCUMENTS_BUTTON_CANCEL_CLICK,
    {
      order_id: orderId,
      has_multiple_orders: hasMultipleOrders.toString(),
    },
  );
};

export const trackingNuvemEnvioPrintDocumentsGeneratingStartLabels = (
  orderId: string,
) => {
  logEvent(NUVEM_ENVIO_PRINT_DOCUMENTS_GENERATING_START_LABELS, {
    order_id: orderId,
    has_loading: 'true',
  });
};

export const trackingNuvemEnvioPrintDocumentsGeneratedPrintLabelsSuccess = (
  orderId: string,
) => {
  logEvent(NUVEM_ENVIO_PRINT_DOCUMENTS_GENERATED_SUCCESS_LABELS, {
    order_id: orderId,
    has_generated_label: 'true',
  });
};

export const trackingNuvemEnvioPrintDocumentsGeneratedErrorLabels = (
  orderId: string,
  errorMessage: string,
) => {
  logEvent(NUVEM_ENVIO_PRINT_DOCUMENTS_GENERATED_ERROR_LABELS, {
    order_id: orderId,
    error_message: errorMessage,
  });
};

export const trackingNuvemEnvioPrintDocumentsGeneratedPrintLabelsClick = (
  orderId: string,
) => {
  logEvent(NUVEM_ENVIO_PRINT_DOCUMENTS_GENERATED_PRINT_LABELS_CLICK, {
    order_id: orderId,
    has_generated_label: 'true',
  });
};
